import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextvaluesPipe } from './pipes/textvalues.pipe'; // Укажите ваш путь
import { TimePeriodPipe } from './pipes/time-period.pipe';

@NgModule({
    declarations: [
        TextvaluesPipe,
        TimePeriodPipe,
    ],
    imports: [CommonModule],
    providers: [
        TextvaluesPipe, 
        TimePeriodPipe],
    exports: [
        TextvaluesPipe,
        TimePeriodPipe,
    ]
})
export class SharedPipesModule { }